import React from "react";
import { Link } from "react-router-dom";
import { Button, Logo } from "../components/ui";

export default function NotFound() {
  return (
    <div className="page-center nf">
      <Logo size={44} text={false} />
      <div className="nf-code">404</div>
      <p className="muted">ไม่พบหน้าที่คุณต้องการ</p>
      <Link to="/chat"><Button variant="primary">กลับไปหน้าแชท</Button></Link>
    </div>
  );
}
